// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2Vvrk","detailsBorder":"styles_detailsBorder__yG_Un"};